module.exports = __webpack_public_path__ + "static/media/Diamond (2).222c35cd.svg";